<app-admin-sidebar></app-admin-sidebar>
<div class="content page" role="main" tabindex="-1" aria-label="Admin Settings page" id="settings">
    <div class="head">
      <h1 i18n="Admin Settings Title|Title of the Admin Settings page@@settingsTitle">Admin Settings</h1>
    </div>
    <div class="contents container-fluid sponsor">
      <h2
        i18n="Institution Information Section Title|A title for the Institution Information section@@settingsInstitutionInformationSectionHeading"
        class="sponsor-title">Institution Information</h2>
      <div class="row sponsor-institution">
        <div class="col-md-6 column-left">
          <div class="form-group">
            <label class="sponsor-text-label"
                   i18n="Institution Name|Name for the Institution@@settingsInstitutionNameLabel" for="sponsorText">Institution
              Name</label>
            <input class="form-control" type="text" id="sponsorText" name="sponsorText"
                   [(ngModel)]="settings.sponsorText" maxlength="40"/>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Institution Label|The name of the institution that will appear beneath the application title@@settingsInstitutionNameText"
            class="help-text-normal institution-name-desc">When set, this text will appear at the top of the EndNote Fusion
            applications for users in your institution. We suggest using just your institution's name, e.g., "University
            of Springfield"</p>
        </div>
      </div>
      <div class="row sponsor-website">
        <div class="col-md-6 column-left">
          <div class="form-group">
            <label i18n="Website Link|The institutions website URL@@settingsInstitutionURLLabel"
                   class="sponsor-website-label" for="sponsorWebsite">Institution Website Link</label>
            <input class="form-control" type="text" id="sponsorWebsite" name="sponsorWebsite"
                   [(ngModel)]="settings.sponsorURL"/>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p i18n="Link to the Institution's Website|Description of the link@@settingsInstitutionURLText"
             class="help-text-normal">Enter a URL (with http:// or https://) here to link to your institution or
            university library.</p>
        </div>
      </div>
    </div>
    <hr/>
    <div class="contents container-fluid link-resolver">
      <h2 i18n="Link Resolver Section Title|A title for the Link Resolver Section@@settingsLinkResolverSectionHeading"
          class="link-resolver-title">Link Resolver</h2>
      <div class="row">
        <div class="col-md-6 column-left">
          <div class="form-group">
            <label class="link-resolver-label"
                   i18n="Label for the Link Resolver|A label given for the Link Resolver@@settingsLinkResolverLabel"
                   for="linkResolverLabel">Link Resolver Label</label>
            <input class="form-control full-text-input" type="text" id="linkResolverLabel" name="linkResolverLabel"
                   [(ngModel)]="settings.linkResolverName" maxlength="35"
                   placeholder="Find full text using link resolver"
                   i18n-placeholder="Link Resolver Custom Name|Custom Name for Link Resolver@@settingsLinkResolverPlaceholder"/>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p i18n="Link Resolver Label Description|Information about the Link Resolver Label@@settingsLinkResolverText"
             class="help-text-normal">If your link resolver has a custom name, you can enter it here. Leave empty to use
            the default text.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 column-left">
          <div class="form-group">
            <label class="link-resolver-url-label"
                   i18n="Link Resolver URL|URL for the Link Resolver@@settingsLinkResolverURLLabel"
                   for="linkResolverURL">Link Resolver URL</label>
            <input class="form-control" type="text" id="linkResolverURL" name="linkResolverURL"
                   [(ngModel)]="settings.linkResolverUrl" placeholder="http://example.org/resolver/"/>
            <div
              i18n="Include HTTP in Text|Instructions for the admin to include http in the URL@@settingsLinkResolverLabelText"
              class="error text-error" *ngIf="invalidURL">Please include http:// or https:// within the link.
            </div>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p i18n="Setting Custom Link|Custom Link Details@@settingsLinkResolverURLText" class="help-text-normal">Set
            the custom link to your institution’s link resolver to direct users to available full-text.</p>
        </div>
      </div>
    </div>
    <hr [hidden]="!settings.wayflessURL"/>
    <div class="contents container-fluid" [hidden]="!settings.wayflessURL">
      <h2 i18n="WAYFless Login Section Title|A title for the Wayless login Section@@settingsWayflessSectionHeading"
          class="link-resolver-title">WAYFless Login</h2>
      <div class="row">
        <div class="col-md-6 column-left">
          <div class="form-group">
            <label i18n="Institution WAYFless|The institutions website URL@@settingsInstitutionWayflessLabel"
                   class="sponsor-website-label" for="wayflessInput">URL</label>
            <div class="input-group">
              <input class="form-control" type="text" id="wayfless-input" name="wayflessInput" readonly
                     [(ngModel)]="settings.wayflessURL"/>
              <span class="input-group-btn">
              <button id="copy-wayfless-btn" class="btn btn-primary copy-wayfless-btn" type="button"
                      (click)="copyWayfless()">
                <i class="uxf-icon uxf-clipboard"></i>
              </button>
            </span>
            </div>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p i18n="Link to the Institution's WAYFless|Description of the link@@settingsInstitutionWayflessText"
             class="help-text-normal">Copy and paste this link on your institution's site to give users direct access to
            their EndNote Fusion account when they are signed-in to an institutional website.</p>
        </div>
      </div>
    </div>
    <hr/>
    <div class="contents container-fluid full-text-sharing">
      <h2 class="full-text-sharing-title"
          i18n="Preferences Section Title|A title for the Preferences section@@settingsPreferencesSectionHeading">
        Preferences</h2>
      <h3 class="preferences-subsection"
          i18n="Preferences AI Features Subsection title|A title for the AI Features subsection of preferences@@settingsPreferencesSectionHeadingAIFeatures">
        AI Features</h3>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="show-research-assistant" name="show-research-assistant"
                   [(ngModel)]="settings.sharingProfile.showResearchAssistant"/>
            <label class="pull-left body-text" for="show-research-assistant"><strong
              i18n="Show Research Assistant Form Label|Label for Show Research Assistant@@settingsShowResearchAssistantLabel">Show Research Assistant feature:</strong>
              <span [ngSwitch]="settings.sharingProfile.showResearchAssistant">
              <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
              <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
            </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for Show Research Assistant when disabled@@settingsShowResearchAssistantDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.showResearchAssistant">Users at
            your institution can NOT access Research Assistant feature. Enable to allow this option for users at your institution.</p>
          <p
            i18n="Enabled Status Messages|Status message for Show Research Assistant when enabled@@settingsShowResearchAssistantEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.showResearchAssistant">Users at
            your institution can access Research Assistant feature. Disable to remove this option for users at your institution.</p>
      </div>
      <div class="row with-spinner show-copyleaks">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="show-copyleaks" name="show-copyleaks"
                   [(ngModel)]="settings.sharingProfile.showCopyleaks"/>
            <label class="pull-left body-text" for="show-copyleaks">
              <strong i18n="Show copyleaks Form Label|Label for Show Copyleaks@@settingsShowCopyleaksLabel">Show
                Plagiarism and AI content checker</strong>
              <strong>:</strong>
              <span [ngSwitch]="settings.sharingProfile.showCopyleaks">
            <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
            <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
          </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for Show Copyleaks when disabled@@settingsShowCopyleaksDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.showCopyleaks">Users at
            your institution can NOT access Plagiarism and AI Content checker feature in EndNote Fusion and EndNote Fusion for Word and Google Docs. Enable to allow this option for users at your institution.</p>
          <p
            i18n="Enabled Status Messages|Status message for Show Copyleaks when enabled@@settingsShowCopyleaksEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.showCopyleaks">Users at
            your institution can access Plagiarism and AI Content checker feature in EndNote Fusion and EndNote Fusion for Word and Google Docs. Disable to remove this option for users at your institution.</p>
        </div>
      </div>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="show-find-a-journal" name="show-find-a-journal"
                   [(ngModel)]="settings.sharingProfile.showFindAJournal"/>
            <label class="pull-left body-text" for="show-find-a-journal"><strong
              i18n="Show Find a Journal Form Label|Label for Show Find a Journal@@settingsShowFindAJournalLabel">Show Find a Journal feature:</strong>
              <span [ngSwitch]="settings.sharingProfile.showFindAJournal">
              <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
              <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
            </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for Show Find a Journal when disabled@@settingsShowFindAJournalDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.showFindAJournal">Users at
            your institution can NOT access Find a Journal feature. Enable to allow this option for users at your institution.</p>
          <p
            i18n="Enabled Status Messages|Status message for Show Find a Journal when enabled@@settingsShowFindAJournalEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.showFindAJournal">Users at
            your institution can access Find a Journal feature. Disable to remove this option for users at your institution.</p>
        </div>
      </div>
      <h3 class="preferences-subsection"
          i18n="Preferences Additional Features Subsection title|A title for the Additional Features subsection of preferences@@settingsPreferencesSectionHeadingAdditionalFeatures">
        Additional Features</h3>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="fulltextSharing" name="fulltextSharing"
                   [(ngModel)]="settings.sharingProfile.fulltextSharing"/>
            <label class="pull-left body-text" for="fulltextSharing"><strong
              i18n="Full-text Sharing Form Label|Label for Full-text sharing@@settingsFullTextSharingLabel">Full-text
              sharing:</strong> <span [ngSwitch]="settings.sharingProfile.fulltextSharing">
            <span class="body-text" *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
            <span class="body-text" *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
          </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for full-text sharing when disabled@@settingsFullTextSharingDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.fulltextSharing">Users at
            your institution may NOT share the full-text of references outside of your institution. They may still share
            the reference metadata. This setting applies to sharing of Folders and does not affect Project sharing.
            Enable to allow members to share full-text items outside of your institution.</p>
          <p
            i18n="Enabled Status Messages|Status message for full-text sharing when enabled@@settingsFullTextSharingEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.fulltextSharing">Users at
            your institution may share the full-text of references outside of your institution. Disable to keep your
            institution's users from sharing full-text with users from other institutions. If disabled, this setting
            applies to sharing of Folders and does not affect Project sharing.</p>
        </div>
      </div>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="searchDatabase" name="searchDatabase"
                   [(ngModel)]="settings.sharingProfile.searchDatabase"/>
            <label class="pull-left body-text" for="searchDatabase"><strong
              i18n="Show Search Databases Form Label|Label for Show Search Databases Sync@@settingsShowSearchDatabasesLabel">Show
              Search Databases:</strong> <span [ngSwitch]="settings.sharingProfile.searchDatabase">
            <span class="enabled" *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
            <span class="disabled" *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
          </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for Show Search Databases when disabled@@settingsShowSearchDatabasesDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.searchDatabase">Users at
            your institution CANNOT search databases from within Endnote Fusion. Enable to allow searching.</p>
          <p
            i18n="Enabled Status Messages|Status message for Show Search Databases when enabled@@settingsShowSearchDatabasesEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.searchDatabase">Users can
            search databases from within Endnote Fusion. Disable to remove this option from the left sidebar for users at your
            institution.</p>
        </div>
      </div>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="dropboxSync" name="dropboxSync"
                   [(ngModel)]="settings.sharingProfile.dropboxSync"/>
            <label class="pull-left body-text" for="dropboxSync"><strong
              i18n="Dropbox Sync Form Label|Label for Dropbox Sync@@settingsDropboxSyncLabel">Sync with
              Dropbox:</strong> <span [ngSwitch]="settings.sharingProfile.dropboxSync">
            <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
            <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
          </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for Dropbox Sync when disabled@@settingsDropboxSyncDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.dropboxSync">Users at your
            institution may NOT sync the full-text of references in their libraries with Dropbox. Enable to allow
            syncing with Dropbox for reading and full-text storage when not online.</p>
          <p i18n="Enabled Status Messages|Status message for Dropbox Sync when enabled@@settingsDropboxSyncEnabledText"
             class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.dropboxSync">Users at your
            institution may sync the full-text of references in their libraries with Dropbox. Disable to keep members
            from syncing their libraries with Dropbox.</p>
        </div>
      </div>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="bx-recommender" name="bx-recommender"
                   [(ngModel)]="settings.sharingProfile.bxRecommender"/>
            <label class="pull-left body-text" for="bx-recommender"><strong
              i18n="bX recommender Form Label|Label for bX recommender@@settingsBxRecommenderLabel">Show bX
              Recommender:</strong> <span [ngSwitch]="settings.sharingProfile.bxRecommender">
            <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
            <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
          </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for bX Recommender when disabled@@settingsBxRecommenderDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.bxRecommender">Users at
            your institution can NOT access bX Recommender feature to find related articles. Enable to allow this option
            for users at your institution.</p>
          <p
            i18n="Enabled Status Messages|Status message for bX Recommender Sync when enabled@@settingsBxRecommenderEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.bxRecommender">Users at
            your institution can access bX Recommender feature to find related articles. Disable to remove this option
            for users at your institution.</p>
        </div>
      </div>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="show-preflight" name="show-preflight"
                   [(ngModel)]="settings.sharingProfile.showPreflight"/>
            <label class="pull-left body-text" for="show-preflight"><strong
              i18n="Show preflight Form Label|Label for Show Preflight@@settingsShowPreflightLabel">Show Preflight
              Pre-submission Check:</strong> <span [ngSwitch]="settings.sharingProfile.showPreflight">
            <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
            <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
          </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for Show Preflight when disabled@@settingsShowPreflightDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.showPreflight">Users at
            your institution can NOT access Preflight Pre-submission Check in EndNote Fusion and EndNote Fusion for Word and Google Docs. Enable to allow this option for users at your institution.</p>
          <p
            i18n="Enabled Status Messages|Status message for Show Preflight when enabled@@settingsShowPreflightEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.showPreflight">Users at
            your institution can access Preflight Pre-submission Check in EndNote Fusion and EndNote Fusion for Word and Google Docs. Disable to remove this option for users at your institution.</p>
        </div>
      </div>
      <div class="find-title">
        <h3 class="preferences-subsection"
            i18n="Preferences Section EndNote Fusion and Find options subsection title|A title for the EndNote Fusion and Find options subsection of preferences@@settingsPreferencesSectionHeadingEndNoteFusionAndFind">
          Endnote Fusion <i>Find</i> options</h3>
        <button id="AdditionalProfileInfoViewSample" class="btn btn-link sample-button" (click)="openFindSampleModal()"
                i18n="Additional Profile Information sample|A sample for the Additional Profile Information Section@@settingsAdditionalProfileInformationSample">
          <u>View Sample</u></button>
      </div>
      <h3 class="find-subtitle"
          i18n="Preferences Section EndNote Fusion and Find options subsection subtitle|A title for the EndNote Fusion and Find options subsection of preferences@@settingsPreferencesSectionSubHeadingEndNoteFusionAndFind">
        When all options are disabled, the <i>Find</i> menu will be hidden on the Reference Details and Reference Editor
        panes</h3>
      <div class="row with-spinner show-pubmed">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="show-pubmed" name="show-pubmed"
                   [(ngModel)]="settings.sharingProfile.showPubMed"/>
            <label class="pull-left body-text" for="show-pubmed"><strong
              i18n="Show PubMed Form Label|Label for Show PubMed@@settingsShowPubMedLabel">Show PubMed links:</strong>
              <span [ngSwitch]="settings.sharingProfile.showPubMed">
              <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
              <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
            </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p i18n="Disable Status Messages|Status message for Show PubMed when disabled@@settingsShowPubMedDisabledText"
             class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.showPubMed">Users at your
            institution can NOT access PubMed links to article, related articles or more articles by author. Enable to
            allow this option for users at your institution.</p>
          <p i18n="Enabled Status Messages|Status message for Show PubMed when enabled@@settingsShowPubMedEnabledText"
             class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.showPubMed">Users at your
            institution can access PubMed links to article, related articles or more articles by author. Disable to
            remove this option for users at your institution.</p>
        </div>
      </div>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="show-doi-search" name="show-doi-search"
                   [(ngModel)]="settings.sharingProfile.showDOISearch"/>
            <label class="pull-left body-text" for="show-doi-search"><strong
              i18n="Show DOI search Form Label|Label for Show DOISearch@@settingsShowDOISearchLabel">Show DOI search
              link:</strong> <span [ngSwitch]="settings.sharingProfile.showDOISearch">
            <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
            <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
          </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for Show DOI search when disabled@@settingsShowDOISearchDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.showDOISearch">Users at
            your institution can NOT access doi.org search related to article. Enable to allow this option for users at
            your institution.</p>
          <p
            i18n="Enabled Status Messages|Status message for Show DOI search when enabled@@settingsShowDOISearchEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.showDOISearch">Users at
            your institution can access doi.org search related to article. Disable to allow this option for users at
            your institution.</p>
        </div>
      </div>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="show-unpaywall" name="show-unpaywall"
                   [(ngModel)]="settings.sharingProfile.showUnpaywall"/>
            <label class="pull-left body-text" for="show-unpaywall"><strong
              i18n="Show Unpaywall Form Label|Label for Show Unpaywall@@settingsShowUnpaywallLabel">Show Unpaywall
              link:</strong> <span [ngSwitch]="settings.sharingProfile.showUnpaywall">
            <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
            <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
          </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for Show Unpaywall when disabled@@settingsShowUnpaywallDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.showUnpaywall">Users at
            your institution can NOT access full text available via Unpaywall. Enable to allow this option for users at
            your institution.</p>
          <p
            i18n="Enabled Status Messages|Status message for Show Unpaywall Sync when enabled@@settingsShowUnpaywallEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.showUnpaywall">Users at
            your institution can access full text available via Unpaywall. Disable to remove this option for users at
            your institution.</p>
        </div>
      </div>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="show-crossref" name="show-crossref"
                   [(ngModel)]="settings.sharingProfile.showCrossref"/>
            <label class="pull-left body-text" for="show-crossref"><strong
              i18n="Show Crossref Form Label|Label for Show Crossref@@settingsShowCrossrefLabel">Show Crossref
              link:</strong> <span [ngSwitch]="settings.sharingProfile.showCrossref">
            <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
            <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
          </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for Show Crossref when disabled@@settingsShowCrossrefDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.showCrossref">Users at
            your institution can NOT access Crossref search related to article. Enable to allow this option for users at
            your institution.</p>
          <p
            i18n="Enabled Status Messages|Status message for Show Crossref when enabled@@settingsShowCrossrefEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.showCrossref">Users at your
            institution can access Crossref search related to article. Disable to allow this option for users at your
            institution.</p>
        </div>
      </div>
      <div class="row with-spinner">
        <div class="col-md-6 column-left">
          <div class="mini-spinner"></div>
          <div class="checkbox checkbox-toggle">
            <input class="checkbox" type="checkbox" id="show-google-scholar" name="show-google-scholar"
                   [(ngModel)]="settings.sharingProfile.showGoogleScholar"/>
            <label class="pull-left body-text" for="show-google-scholar"><strong
              i18n="Show Google Scholar Form Label|Label for Show Google Scholar@@settingsShowGoogleScholarLabel">Show
              Google Scholar link:</strong> <span [ngSwitch]="settings.sharingProfile.showGoogleScholar">
            <span *ngSwitchCase="true" i18n="@@settingsEnabledText">&nbsp;Enabled</span>
            <span *ngSwitchCase="false" i18n="@@settingsDisabledText">&nbsp;Disabled</span>
          </span></label>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Disable Status Messages|Status message for Show Google Scholar when disabled@@settingsShowGoogleScholarDisabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="!settings.sharingProfile.showGoogleScholar">Users
            at your institution can NOT access Google Scholar search related to article. Enable to allow this option for
            users at your institution.</p>
          <p
            i18n="Enabled Status Messages|Status message for Show Google Scholar when enabled@@settingsShowGoogleScholarEnabledText"
            class="help-text-normal full-text-sharing-status" *ngIf="settings.sharingProfile.showGoogleScholar">Users at
            your institution can access Google Scholar search related to article. Disable to allow this option for users
            at your institution.</p>
        </div>
      </div>
    </div>
    <hr/>
    <div class="contents container-fluid citation-style">
      <h2 class="citation-style-title"
          i18n="Citation Style Section Title|A title for the Citation Styles section@@settingsMyInstitutionCitationStyleSectionHeading">
        Citation Styles for My Institution</h2>
      <div class="row">
        <div class="col-md-6 column-left">
          <label class="def-citation-style"
                 i18n="Default Citation Styles Sub-heading|Head for the Default Citation Styles@@settingsForDefaultCitationStylesLabel">Citation
            styles</label>
          <div class="spinner" *ngIf="styleList.length == 0"></div>
          <div *ngIf="styleList.length > 0">
            <div class="form-group">
              <label for="defaultCitationStyles1" class="sr-only">Default Citation Style 1</label>
              <div class="input-group">
                <div class="input-group-addon">1</div>
                <input type="text" class="form-control default-citation-style" (click)="$event.target.select()"
                       [(ngModel)]="styleList[0]" id="defaultCitationStyles1" name="defaultCitationStyles1"
                       placeholder="{{ 'Search by style name e.g. ‘Japanese Journal’, ‘Harvard - British Standard’' }}"
                       (focus)="focusedIndex =  0" (keyup)="onInputKeyUp($event)" (blur)="onTypeaheadBlur($event)"/>
                <ul class="typeahead" [ngClass]="{ hidden: focusedIndex !== 0 }">
                  <li *ngFor="let style of defaultStylesList | slice:0:10" (click)="selectStyle(style, 0)"
                      data-id="{{ style.id }}">
                    {{ style.name }}
                    <small class="style-owner" *ngIf="style.ownership">{{ style.ownership }}</small>
                  </li>
                  <li *ngIf="defaultStylesList.length === 0" i18n="@@settingsDefaultCitationStyleNoResults">No results
                    found
                  </li>
                </ul>
              </div>
            </div>
            <div class="form-group">
              <label for="defaultCitationStyles2" class="sr-only">Default Citation Style 2</label>
              <div class="input-group">
                <div class="input-group-addon">2</div>
                <input type="text" class="form-control default-citation-style" (click)="$event.target.select()"
                       [(ngModel)]="styleList[1]" id="defaultCitationStyles2" name="defaultCitationStyles2"
                       placeholder="{{ 'Search by style name e.g. ‘Japanese Journal’, ‘Harvard - British Standard’' }}"
                       (focus)="focusedIndex = 1" (keyup)="onInputKeyUp($event)" (blur)="onTypeaheadBlur($event)"/>
                <ul class="typeahead" [ngClass]="{hidden: focusedIndex !== 1 }">
                  <li *ngFor="let style of defaultStylesList | slice:0:10" (click)="selectStyle(style, 1)"
                      data-id="{{ style.id }}">
                    {{ style.name }}
                    <small class="style-owner" *ngIf="style.ownership">{{ style.ownership }}</small>
                  </li>
                  <li *ngIf="defaultStylesList.length === 0" i18n="@@settingsDefaultCitationStyleNoResults">No results
                    found
                  </li>
                </ul>
              </div>
            </div>
            <div class="form-group">
              <label for="defaultCitationStyles3" class="sr-only">Default Citation Style 3</label>
              <div class="input-group">
                <div class="input-group-addon">3</div>
                <input type="text" class="form-control default-citation-style" (click)="$event.target.select()"
                       [(ngModel)]="styleList[2]" id="defaultCitationStyles3" name="defaultCitationStyles3"
                       placeholder="{{ 'Search by style name e.g. ‘Japanese Journal’, ‘Harvard - British Standard’' }}"
                       (focus)="focusedIndex = 2" (keyup)="onInputKeyUp($event)" (blur)="onTypeaheadBlur($event)"/>
                <ul class="typeahead" [ngClass]="{hidden: focusedIndex !== 2 }">
                  <li *ngFor="let style of defaultStylesList | slice:0:10" (click)="selectStyle(style, 2)"
                      data-id="{{ style.id }}">
                    {{ style.name }}
                    <small class="style-owner" *ngIf="style.ownership">{{ style.ownership }}</small>
                  </li>
                  <li *ngIf="defaultStylesList.length === 0" i18n="@@settingsDefaultCitationStyleNoResults">No results
                    found
                  </li>
                </ul>
              </div>
            </div>
            <div class="form-group">
              <label for="defaultCitationStyles4" class="sr-only">Default Citation Style 4</label>
              <div class="input-group">
                <div class="input-group-addon">4</div>
                <input type="text" class="form-control default-citation-style" (click)="$event.target.select()"
                       [(ngModel)]="styleList[3]" id="defaultCitationStyles4" name="defaultCitationStyles4"
                       placeholder="{{ 'Search by style name e.g. ‘Japanese Journal’, ‘Harvard - British Standard’' }}"
                       (focus)="focusedIndex = 3" (keyup)="onInputKeyUp($event)" (blur)="onTypeaheadBlur($event)"/>
                <ul class="typeahead" [ngClass]="{hidden: focusedIndex !== 3 }">
                  <li *ngFor="let style of defaultStylesList | slice:0:10" (click)="selectStyle(style, 3)"
                      data-id="{{ style.id }}">
                    {{ style.name }}
                    <small class="style-owner" *ngIf="style.ownership">{{ style.ownership }}</small>
                  </li>
                  <li *ngIf="defaultStylesList.length === 0" i18n="@@settingsDefaultCitationStyleNoResults">No results
                    found
                  </li>
                </ul>
              </div>
            </div>
            <div class="form-group">
              <label for="defaultCitationStyles5" class="sr-only">Default Citation Style 5</label>
              <div class="input-group">
                <div class="input-group-addon">5</div>
                <input type="text" class="form-control default-citation-style" (click)="$event.target.select()"
                       [(ngModel)]="styleList[4]" id="defaultCitationStyles5" name="defaultCitationStyles5"
                       placeholder="{{ 'Search by style name e.g. ‘Japanese Journal’, ‘Harvard - British Standard’' }}"
                       (focus)="focusedIndex = 4" (keyup)="onInputKeyUp($event)" (blur)="onTypeaheadBlur($event)"/>
                <ul class="typeahead" [ngClass]="{hidden: focusedIndex !== 4 }">
                  <li *ngFor="let style of defaultStylesList | slice:0:10" (click)="selectStyle(style, 4)"
                      data-id="{{ style.id }}">
                    {{ style.name }}
                    <small class="style-owner" *ngIf="style.ownership">{{ style.ownership }}</small>
                  </li>
                  <li *ngIf="defaultStylesList.length === 0" i18n="@@settingsDefaultCitationStyleNoResults">No results
                    found
                  </li>
                </ul>
              </div>
            </div>
            <div class="form-group">
              <label for="defaultCitationStyles6" class="sr-only">Default Citation Style 6</label>
              <div class="input-group">
                <div class="input-group-addon">6</div>
                <input type="text" class="form-control default-citation-style" (click)="$event.target.select()"
                       [(ngModel)]="styleList[5]" id="defaultCitationStyles6" name="defaultCitationStyles6"
                       placeholder="{{ 'Search by style name e.g. ‘Japanese Journal’, ‘Harvard - British Standard’' }}"
                       (focus)="focusedIndex = 5" (keyup)="onInputKeyUp($event)" (blur)="onTypeaheadBlur($event)"/>
                <ul class="typeahead" [ngClass]="{hidden: focusedIndex !== 5 }">
                  <li *ngFor="let style of defaultStylesList | slice:0:10" (click)="selectStyle(style, 5)"
                      data-id="{{ style.id }}">
                    {{ style.name }}
                    <small class="style-owner" *ngIf="style.ownership">{{ style.ownership }}</small>
                  </li>
                  <li *ngIf="defaultStylesList.length === 0" i18n="@@settingsDefaultCitationStyleNoResults">No results
                    found
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p
            i18n="Bibliography and Citation Style|Info for the admin when a user creates a bibliography@@settingsForCustomStylesCreatedText"
            class="muted">When users create citations or a bibliography, they can choose any available citation style.
            Choose up to 6 styles that will show up in the users' <strong>Recent styles</strong> menu when they start
            using Endnote Fusion.</p>
          <p class="muted">
            <span
              i18n="Custom Styles|Additional info for choosing a custom style start@@settingsCustomStyleChosenTextStart">Note: You can choose</span>
            <span class="institutional-green"
                  i18n="Custom Styles|Additional info for choosing a institution style@@settingsCustomInstitutionStyle"> "Institutional styles" </span>
            <span
              i18n="Custom Styles|Additional info for choosing a custom style end@@settingsCustomStyleChoosenTextEnd">as well, and they will appear in the <strong>Recent styles</strong> menu in addition to appearing in the <strong>Institutional styles</strong> menu. Share a custom style or an existing style (after renaming it) with your institution using the </span>
            <u><a i18n="link to citation style editor|navigation link" href="/citationstyle/list/"
                  i18n="Citation Style Editor Link|A link to the Citation Style Editor">Citation Style Editor</a></u>
          </p>
        </div>
      </div>
    </div>
    <hr/>
    <div class="contents container-fluid additional-profile">
      <div class="additional-title">
        <h2
          i18n="Additional Profile Information Section Title|A title for the Additional Profile Information Section@@settingsAdditionalProfileInformationSectionHeading">
          Additional Profile Information
        </h2>
        <button id="AdditionalProfileInfoViewSample" class="btn btn-link additionalButton" (click)="openExampleModal()"
                i18n="Additional Profile Information sample|A sample for the Additional Profile Information Section@@settingsAdditionalProfileInformationSample">
          <u>View Sample</u></button>
      </div>
      <p id="additional-profile-information-description"
         i18n="Additional Profile Information Label Description|Information about the Additional Profile Information Label@@settingsAdditionalProfileInformationDescription"
         class="body-text profile-info-desc">
        Include additional profile information by creating a custom dropdown. It must have a label and at least two
        answer choices. If the label and answer choices are left blank or deleted,
        a dropdown will not appear on the profile creation screen or in the users' Settings.
      </p>
      <div class="row additional-profile-content">
        <div class="col-md-6 column-left">
          <div class="form-group">
            <label class="additional-profile-label" id="additional-profile-label"
                   i18n="Label for Label Name@@settingsLabelNameLabel" for="additional-profile-name">Label</label>
            <input id="additional-profile-name" class="form-control"
                   [ngClass]="{'red-border-class': invalidAdditionalInfoLabel}" type="text"
                   name="additional-profile-nam" [(ngModel)]="settings.additionalProfileInformationName"
                   maxlength="100"/>
            <div *ngIf="invalidAdditionalInfoLabel" class="errors-field-additional">
            <span id="label-missing-text"
                  i18n="Missing label text|Instructions for the admin to include a label@@settingsAdditionalProfileInformationLabelMissingText"
                  class="error text-danger">
              Answer choices must have a label.
            </span>
            </div>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p id="additional-profile-information-label-description"
             i18n="Additional Profile Information Label Description|Information about the Additional Profile Information Label@@settingsAdditionalProfileInformationText"
             class="help-text-normal additional-profile-label-desc">
            Enter a label for the drop down. This will be a required field for the user.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 column-left">
          <div class="form-group">
            <label class="additional-profile-answers-label" id="additional-profile-answers-label"
                   i18n="Additional Profile Information Answers|Answers for the Additional Profile Information@@settingsAdditionalProfileInformationAnswersLabel"
                   for="additional-profile-answers-list">Answer Choices</label>
            <textarea id="additional-profile-answers-list" class="form-control text-area"
                      [ngClass]="{'red-border-class': invalidAnswer}" rows="10" name="additional-profile-answers-list"
                      [(ngModel)]="additionalProfileAnswersList"></textarea>
            <div class="errors-field-additional">
            <span id="additional-profile-answers-list-error"
                  i18n="Include more than one answer|Instructions for the admin to include more than one answer@@settingsAdditionalProfileInformationAnswerText"
                  class="error text-danger" [hidden]="!invalidAnswer">
              A label must have at least two answers.
            </span>
            </div>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p id="additional-profile-information-answers-description-first"
             i18n="Setting Answers|Answers Details@@settingsAdditionalProfileInformationAnswerDetailText"
             class="help-text-normal">Enter each answer on a separate line. Values will be displayed in the order in
            which they appear in the box.</p>
          <p id="additional-profile-information-answers-description-second"
             i18n="Setting Answers|Answers Details@@settingsAdditionalProfileInformationAnswerDetailSecondText"
             class="help-text-normal">If you change the order of previously saved answers, there will be no effect on
            users who had those answers.</p>
          <p id="additional-profile-information-answers-description-third"
             i18n="Setting Answers|Answers Details@@settingsAdditionalProfileInformationAnswerDetailThirdText"
             class="help-text-normal">If you edit or delete a previously saved answer, all users who had that answer
            will now have an empty field; they can reselect an answer in Settings.</p>
        </div>
      </div>
    </div>
    <hr/>
    <div class="contents container-fluid profile-creation-message">
      <div class="profile-creation-title">
        <h2 id="profile-cration-message-header" class="profile-creation-message-header"
            i18n="Profile Creation Message Section Title|A title for the Profile Creation Message Section@@settingsProfileCreationMessageSectionHeading">
          Profile Creation Message</h2>
      </div>
      <div class="row">
        <div class="col-md-6 column-left">
          <div class="form-group">
            <label class="profile-creation-message-label"
                   i18n="Profile Creation Message Label|Label of the Profile Creation Message textbox@@settingsProfileCreationMessageLabel">Message</label>
            <textarea class="form-control message-text-area" rows="3" id="profileCreationMessage"
                      name="profileCreationMessage" maxlength="250"
                      [(ngModel)]="settings.profileCreationMessage"></textarea>
            <p id="max-characters-warning"
               i18n="Max letters|Defines the maximum amount of letters allowed@@settingssProfileCreationMessageMaxLettersText"
               class="help-text-light-small">
              Maximum 250 characters
            </p>
          </div>
        </div>
        <div class="col-md-6 column-right">
          <p id="profile-creation-message-detail-text"
             i18n="Profile Creation Message Description|Information about the Profile Creation Message textbox@@settingsProfileCreationMessageDetailText"
             class="help-text-normal creation-message-detail-text">
            Enter text that will appear in the profile creation screen.
          </p>
        </div>
      </div>
    </div>
    <div class="frozen row button-row">
      <button id="saveBtn" i18n="Save Button|A label for the button that saves the form@@settingsSaveButtonText"
              class="btn pull-right save-options" (click)="updateSettings($event)">Save
      </button>
    </div>
    <span class="hidden" #toasterCopiedWayfless i18n="@@settingsWayflessCopied">WAYFless login URL copied.</span>
  </div>
